import Swiper from "swiper/js/swiper.min";
import TweenMax from "gsap/TweenMax"
import Chocolat from "chocolat";
// import TimelineMax from "gsap/TimelineMax"
import ScrollMagic from "ScrollMagic";
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators'

export default {
    init() {
        // build array of years
        let yearAry = [];

        $(".history-slide").each(function () {
            const year = $(this).data('year');
            yearAry.push(year);
        });

        const historyFeature = document.querySelector('.history-feature');

        const historyCarousel = new Swiper('.history-carousel__container', {
            slidesPerView: 1,
            effect: "fade",
            observer: true,
            observeParents: true,
            autoHeight: true,
            loop: true,
            allowTouchMove: false,
            noSwiping: true,
            on: {
                transitionEnd: function() {
                    $(".history-carousel__container .swiper-slide-active").addClass("animate");
                    $(".history-carousel__container .swiper-slide:not(.swiper-slide-active)").removeClass("animate");
                },
            },
            pagination: {
                // el: historyFeature.querySelector('.swiper-pagination'),
                // type: 'fraction',
            },
            navigation: {
                nextEl: historyFeature.querySelector('.history-feature__swiper-btn--next'),
                prevEl: historyFeature.querySelector('.history-feature__swiper-btn--prev'),
            },
        });

        // parallax scroll through images

        class dateRangeSlider {
            constructor(element, yearArray, linkedCarousel) {
                this.yearArray = yearArray;
                this.linkedCarousel = linkedCarousel;
                this.rangeSlider = element;

                this.initRangeSlider();
            }

            /**
             * Setup range slider and add event callbacks
             */
            initRangeSlider() {
                this.rangeSlider.ionRangeSlider({
                    type: "single",
                    skin: "round",
                    grid: true,
                    hide_min_max: true,
                    values: this.yearArray,
                    min: 0,
                    max: (this.yearArray.length-1),
                    prettify_enabled: false,
                    from: 0,
                    onUpdate: (data) => {
                        this.updateVisibleSlide(data.from + 1);
                        this.highlightActive(data.from);
                    },
                    onStart: (data) => {
                        this.highlightActive(data.from);
                        this.addMarkerClickEvents();
                    },
                    onFinish: (data) => {
                        this.updateVisibleSlide(data.from + 1);
                        this.highlightActive(data.from);
                    },
                });

                this.rangeSliderInstance = $(this.rangeSlider).data('ionRangeSlider');
            }

            /**
             * Highlights active year on range slider
             * @param rangeIndex
             */
            highlightActive(rangeIndex) {
                $(".irs-grid .irs-grid-text.current").removeClass('current');
                $(".irs-grid .irs-grid-text").eq(rangeIndex).addClass('current');
            }

            /**
             * Adds click events to markers underneath
             * range slider
             */
            addMarkerClickEvents() {
                let _this = this;
                $(".history-range").on("click", ".irs-grid-text", function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    let $parent = $(this).closest('.irs-grid');
                    let goto = $('.irs-grid-text', $parent).index($(this));

                    _this.rangeSliderInstance.update({
                        from: goto,
                    });
                });
            }

            /**
             * Slides to {slideIndex} slide on linked swiper
             * @param slideIndex
             */
            updateVisibleSlide(slideIndex) {
                this.linkedCarousel.slideTo(slideIndex);
            }

            /**
             * Returns data ionRangeSlider instance
             * which provides access to ionRangeSlider methods
             * @returns ionRangeSlider
             */
            getDataInstance() {
                return this.rangeSlider.data("ionRangeSlider");
            }
        }

        new dateRangeSlider($(".js-range-slider"), yearAry, historyCarousel);

        /**
         * Awards gallery images
         */
        Chocolat(document.querySelectorAll('.chocolat-parent .chocolat-image'));

        /**
         * Cycle through images on page scroll.
         * @todo: reuse this code instead or repeat (careers)
         */
        (() => {
            jQuery.fn.reverse = [].reverse;

            $(".our-story-feature").each(function () {
                createTween($(this));
            });

            function createTween($featureElement)
            {
                var controller = new ScrollMagic.Controller();

                let images = $(".fifty-fifty-image-feature__animated-image > .animated-image-container", $featureElement).get().reverse();

                if (images.length > 1) {
                    $(images).each(function (index, element) {
                        let tween = TweenMax.to(
                            element, 0.33, {opacity: 1, ease: "Power2.easeInOut"});

                        new ScrollMagic.Scene({
                            triggerElement: $featureElement.get(0),
                            offset: -Math.abs(-Math.abs(window.innerHeight / $(images).length) * index),
                            triggerHook: 0,
                        })
                            .setTween(tween) // add class toggle
                            // .addIndicators({name: "digit " + (index + 1) }) // add indicators (requires plugin)
                            .addTo(controller);
                    });
                } else {
                    images[0].style.opacity = 1;
                }
            }
        })();
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/ourStory.js